/* eslint-disable react/require-default-props */
/* eslint-disable max-statements-per-line */
/* eslint-disable max-len */
import type { ComponentProps } from 'react';
// import { useMemo, useEffect, useState } from 'react';
// eslint-disable-next-line import/no-named-as-default
// import toast from 'react-hot-toast';
// import Select from 'react-select';

import {
    Button,
    ButtonVariant,
    // BarChart,
    // Toast,
    transformCurrency,
} from '@catalyze/ui';
import type { IPropertyCount } from 'api/products/getProducts';

import {
    BillingPeriod,
    BillingPeriod2,
    Price,
    Price2,
    Title,
    Container,
    Row,
    FormSubtitle,
} from './styled';

// import { addFilterAction } from 'features/RealEstate/context/FilterContext';

type IPlanProps = ComponentProps<typeof Container> & {
    name: string;
    price: string;
    billingPeriod?: string;
    onSubscribe: (count: number, price_id: string) => void;
    loading?: boolean;
    useCount?: boolean;
    count?: number;
    description?: string;
    zip?: string;
    subscriptionId: string;
    propertyDistribution?: IPropertyCount[];
    // onProductSelectionUpdate?: (count: number, isAddedToCart: boolean) => void;
};

export const PlanAGAD = ({
    name,
    price,
    billingPeriod,
    onSubscribe,
    loading,
    useCount,
    // onProductSelectionUpdate,
    description,
    subscriptionId,
    count,
    zip,
    propertyDistribution,
    ...props
}: IPlanProps): JSX.Element => {
    return (
        <Container {...props}>
            <Title>{name}</Title>
            <Row>
                <Price2>{transformCurrency(price)}</Price2>
                <BillingPeriod2>/{billingPeriod}</BillingPeriod2>
            </Row>
            {description && <FormSubtitle>{description}</FormSubtitle>}
            <Row>
                <Price>
                    {transformCurrency(parseInt(price, 10).toString())}
                </Price>
                <BillingPeriod>/{billingPeriod} total</BillingPeriod>
            </Row>

            <Button
                variant={ButtonVariant.PRIMARY}
                onClick={() => onSubscribe(1, subscriptionId)}
                disabled={loading}
                // disabled={loading || (count && selectedAmount === 0)}
            >
                Subscribe
            </Button>
        </Container>
    );
};
